import { useEffect } from 'react'
import { NavLink, useNavigate } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import { Contact, FileSignature, FolderKanban, Home, LogOut, Mail, Search, UserCog } from 'lucide-react'
import { useAuthStore } from '../../stores/authStore.js'
import { getCurrentUser } from '../../services/api.js'
import { hasModule } from '../../features/access/modules.js'
import { CRM_BASES } from '../../features/crm/bases.js'
import BrandLogo from '../common/BrandLogo.jsx'

export default function Sidebar() {
  const navigate = useNavigate()
  const authUser = useAuthStore((state) => state.user)
  const setUser = useAuthStore((state) => state.setUser)
  const { logout } = useAuthStore()
  const { data: me } = useQuery({
    queryKey: ['currentUser'],
    queryFn: getCurrentUser,
    staleTime: 60000,
  })

  const user = me ?? authUser

  useEffect(() => {
    if (me) {
      setUser(me)
    }
  }, [me, setUser])

  const handleLogout = () => {
    logout()
    navigate('/login', { replace: true })
  }

  // Une entrée par grand métier ; le détail se choisit par les onglets en haut de chaque page
  // (sources de Prospection, bases du CRM, sous-pages de Compte).
  const hasAnyCrmBase = CRM_BASES.some((base) => !base.module || hasModule(user, base.module))
  const navItems = [
    { to: '/dashboard', label: 'Accueil', icon: Home, end: true, visible: true },
    {
      to: '/dashboard/prospection',
      label: 'Prospection',
      icon: Search,
      visible: ['prospects', 'immobilier', 'france_travail'].some((m) => hasModule(user, m)),
    },
    { to: '/dashboard/communication', label: 'Communication', icon: Mail, visible: hasModule(user, 'communication') },
    { to: '/dashboard/crm', label: 'CRM', icon: Contact, visible: hasAnyCrmBase },
    { to: '/dashboard/serge-projects', label: 'Offre', icon: FolderKanban, visible: true },
    { to: '/dashboard/contrats', label: 'Contrats', icon: FileSignature, visible: hasModule(user, 'prospects') },
    { to: '/dashboard/compte', label: 'Compte', icon: UserCog, visible: true },
  ].filter((item) => item.visible)

  return (
    <aside className="sidebar">
      <div className="sidebar-header">
        <BrandLogo className="sidebar-logo" />
      </div>

      <nav className="sidebar-nav">
        {navItems.map((item) => {
          const Icon = item.icon
          return (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
            >
              <Icon size={18} />
              <span>{item.label}</span>
            </NavLink>
          )
        })}

        <div className="nav-divider" />

        <button className="nav-item logout-item" onClick={handleLogout} type="button">
          <LogOut size={18} />
          <span>Déconnexion</span>
        </button>
      </nav>
    </aside>
  )
}
